import ENDPOINTS from "../config/apiUrls";
import axiosInstance from "../config/axiosInstance";

export const purgeCloudflareCache = async (stationGroup) => {
  if (!stationGroup) {
    console.warn("No stationGroup provided for cache purge");
    return false;
  }

  try {
    // Handle multiple stationGroups
    const stationGroups = stationGroup
      .split(",")
      .map(sg => sg.trim())
      .filter(Boolean);

    // Build URLs
    const urls = stationGroups.map(sg => {
      const filter = encodeURIComponent(
        JSON.stringify({ stationGroup: sg })
      );
      return `${process.env.REACT_APP_API_BASE_URL}/users/list?limit=100&offset=0&filter=${filter}`;
    });

    await axiosInstance.post(ENDPOINTS.CLOUDFLARE.PURGE_CACHE, urls);



    console.log("Cloudflare cache purged for:", urls);
    return true;
  } catch (error) {
    console.error(
      "Failed to purge Cloudflare cache:",
      error.response?.data || error.message
    );
    return false;
  }
};
